import React from 'react';
import SafeIcon from '../../common/SafeIcon';

const PreorderBanner = () => {
  return (
    <div className="bg-frost-ice border-y border-frost-ice-dark py-3">
      <div className="max-w-7xl mx-auto px-4 flex flex-col md:flex-row items-center justify-between gap-4 text-sm font-medium text-frost-berry">
        
        <div className="flex items-center gap-2">
          <SafeIcon icon="FiThermometer" className="text-lg" />
          <span>Cold-Chain Guarantee: Arrives deeply frozen at -109°F</span>
        </div>

        <div className="hidden md:block w-px h-4 bg-frost-berry/20"></div>

        <div className="flex items-center gap-2">
          <SafeIcon icon="FiClock" className="text-lg" />
          <span className="flex items-center gap-2">
            <span>Next Ship Date: <strong className="font-bold">Next Monday</strong></span>
            <span className="bg-frost-berry text-white px-2 py-0.5 rounded text-xs animate-pulse">
              Order by Wed 11:59PM
            </span>
          </span>
        </div>

        <div className="hidden md:block w-px h-4 bg-frost-berry/20"></div>

        <div className="flex items-center gap-2">
          <SafeIcon icon="FiTruck" className="text-lg" />
          <span>Shipping to lower 48 states only</span>
        </div>

      </div>
    </div>
  );
};

export default PreorderBanner;